/* TUNDRA PRINT â€” tundra-home.js
   Upload to: Online Store > Themes > Edit code > Assets > Add new asset
*/
(function(){
  // How-it-works auto stepper
  var howBtns = document.querySelectorAll('#tpHow .tp-how__btn');
  var progress = document.getElementById('tpHowProgress');
  var curStep = 0;
  function setStep(n){
    curStep = n;
    howBtns.forEach(function(b,k){ b.classList.toggle('on', k===n); });
    if(progress) progress.style.width = (8 + (n/(howBtns.length-1))*76) + '%';
  }
  howBtns.forEach(function(b,k){ b.addEventListener('click', function(){ setStep(k); resetAuto(); }); });
  var howTimer;
  function resetAuto(){ clearInterval(howTimer); howTimer = setInterval(function(){ setStep((curStep+1)%howBtns.length); }, 2800); }
  if(howBtns.length){ setStep(0); resetAuto(); }
  var howSec = document.querySelector('.tp-how');
  if(howSec){
    howSec.addEventListener('mouseenter', function(){ clearInterval(howTimer); });
    howSec.addEventListener('mouseleave', resetAuto);
  }

  // Profit calculator
  var EU = '\u20ac';
  var products = {
    poster:     { label:'Poster',        sizes:[{label:'13x18cm',cost:4.75},{label:'15x20cm',cost:5.25},{label:'20x30cm',cost:6.00},{label:'30x30cm',cost:6.25},{label:'30x40cm',cost:7.00},{label:'30x45cm',cost:8.00},{label:'40x50cm',cost:8.20},{label:'45x60cm',cost:9.50},{label:'50x50cm',cost:9.00},{label:'50x70cm',cost:10.50},{label:'60x80cm',cost:11.50},{label:'60x90cm',cost:12.50},{label:'70x70cm',cost:14.00},{label:'70x100cm',cost:16.00}], link:'https://tundraprint.com/products/poster' },
    framed:     { label:'Framed Print',  sizes:[{label:'13x18cm',cost:15.00},{label:'15x20cm',cost:20.00},{label:'20x30cm',cost:23.00},{label:'30x30cm',cost:26.00},{label:'30x40cm',cost:35.00},{label:'30x45cm',cost:44.00},{label:'40x50cm',cost:55.00},{label:'45x60cm',cost:61.00},{label:'50x50cm',cost:58.00},{label:'50x70cm',cost:69.00},{label:'60x80cm',cost:74.00},{label:'60x90cm',cost:86.00},{label:'70x70cm',cost:82.00},{label:'70x100cm',cost:96.00}], link:'https://tundraprint.com/products/framed-poster' },
    card:       { label:'Greeting Card', sizes:[{label:'A5',cost:4.00},{label:'A6',cost:4.25},{label:'A7',cost:4.50}], link:'https://tundraprint.com/products/greeting-card' },
    tshirt:     { label:'T-Shirt',       sizes:[{label:'All sizes',cost:13.00}], link:'https://tundraprint.com/products/tshirt' },
    hoodie:     { label:'Hoodie',        sizes:[{label:'All sizes',cost:32.00}], link:'https://tundraprint.com/products/hoodie' },
    sweatshirt: { label:'Sweatshirt',    sizes:[{label:'All sizes',cost:32.00}], link:'https://tundraprint.com/products/sweatshirt' },
    totebag:    { label:'Tote Bag',      sizes:[{label:'All sizes',cost:10.00}], link:'https://tundraprint.com/products/tote-bag' }
  };
  var calcState = { product:'poster', sizeIdx:0 };
  var calcItems = [];
  var productSel = document.getElementById('tpProduct');
  var sizesWrap  = document.getElementById('tpSizes');
  var unitsInput = document.getElementById('tpUnits');
  var priceInput = document.getElementById('tpPrice');
  var itemsWrap  = document.getElementById('tpItems');
  var emptyMsg   = document.getElementById('tpEmpty');
  if(!productSel) return;

  function buildSizes(){
    sizesWrap.innerHTML = '';
    var sizes = products[calcState.product].sizes;
    if(calcState.sizeIdx >= sizes.length) calcState.sizeIdx = 0;
    var isSingle = sizes.length === 1;
    sizesWrap.classList.toggle('hidden', isSingle);
    document.getElementById('tpSizeLabel').classList.toggle('hidden', isSingle);
    sizes.forEach(function(s,i){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tp-calc__size' + (i===calcState.sizeIdx?' on':'');
      b.textContent = s.label;
      b.addEventListener('click', function(){ calcState.sizeIdx=i; buildSizes(); });
      sizesWrap.appendChild(b);
    });
  }

  function addItem(){
    var prod   = products[calcState.product];
    var size   = prod.sizes[calcState.sizeIdx];
    var units  = Math.max(1, parseInt(unitsInput.value)||1);
    var sell   = Math.max(0, parseFloat(priceInput.value)||0);
    var profit = (sell - size.cost) * units;
    calcItems.push({ id:Date.now(), productKey:calcState.product, productLabel:prod.label, sizeLabel:size.label, cost:size.cost, units:units, sell:sell, profit:profit, revenue:sell*units, totalCost:size.cost*units, link:prod.link });
    renderItems();
    renderTotals();
  }

  function removeItem(id){
    calcItems = calcItems.filter(function(i){ return i.id !== id; });
    renderItems();
    renderTotals();
  }

  function renderItems(){
    emptyMsg.style.display = calcItems.length ? 'none' : 'block';
    itemsWrap.querySelectorAll('.tp-calc__item').forEach(function(el){ el.remove(); });
    calcItems.forEach(function(item){
      var div = document.createElement('div');
      div.className = 'tp-calc__item';
      div.innerHTML =
        '<div class="tp-calc__item-info">' +
          '<div class="tp-calc__item-name">' + item.productLabel + (item.sizeLabel !== 'All sizes' ? ' &middot; ' + item.sizeLabel : '') + '</div>' +
          '<div class="tp-calc__item-detail">' + item.units + ' units &middot; sell ' + EU + item.sell.toFixed(2) + ' &middot; cost ' + EU + item.cost.toFixed(2) + '</div>' +
        '</div>' +
        '<div style="display:flex;align-items:center;gap:12px">' +
          '<div class="tp-calc__item-profit">' + EU + (item.profit>0?item.profit.toFixed(2):'0.00') + '</div>' +
          '<button class="tp-calc__item-remove" data-id="' + item.id + '" title="Remove">&times;</button>' +
        '</div>';
      div.querySelector('.tp-calc__item-remove').addEventListener('click', function(){ removeItem(item.id); });
      itemsWrap.appendChild(div);
    });
  }

  function renderTotals(){
    var totRev    = calcItems.reduce(function(s,i){ return s+i.revenue; },0);
    var totCost   = calcItems.reduce(function(s,i){ return s+i.totalCost; },0);
    var totProfit = calcItems.reduce(function(s,i){ return s+i.profit; },0);
    var totMargin = totRev > 0 ? (totProfit/totRev*100) : 0;
    var totalsEl  = document.getElementById('tpTotals');
    var bdEl      = document.getElementById('tpBreakdown');
    document.getElementById('tpTotal').textContent = EU + (totProfit>0?totProfit.toFixed(2):'0.00');
    document.getElementById('tpPer').textContent   = calcItems.length ? (EU+(totProfit>0?totProfit.toFixed(2):'0.00')+' across '+calcItems.length+' product line'+(calcItems.length>1?'s':'')) : 'Add a product to see results';
    if(calcItems.length){
      totalsEl.style.display = 'flex';
      document.getElementById('tpRevTotal').textContent   = EU+totRev.toFixed(2);
      document.getElementById('tpCostTotal').textContent  = EU+totCost.toFixed(2);
      document.getElementById('tpMarginTotal').textContent = (totMargin>0?totMargin.toFixed(1):'0.0')+'%';
      var rows = '';
      calcItems.forEach(function(item){
        var margin = item.revenue>0?(item.profit/item.revenue*100):0;
        rows += '<div class="tp-calc__breakdown-row"><span>'+item.productLabel+(item.sizeLabel!=='All sizes'?' '+item.sizeLabel:'')+' x'+item.units+'</span><span style="color:#4ade80;font-weight:700">'+EU+(item.profit>0?item.profit.toFixed(2):'0.00')+' ('+(margin>0?margin.toFixed(0):'0')+'%)</span></div>';
      });
      bdEl.innerHTML = rows;
      document.getElementById('tpOrder').href = calcItems[calcItems.length-1].link;
    } else {
      totalsEl.style.display = 'none';
      bdEl.innerHTML = '';
    }
  }

  productSel.addEventListener('change', function(){ calcState.product=this.value; calcState.sizeIdx=0; buildSizes(); });
  document.getElementById('tpAdd').addEventListener('click', addItem);
  buildSizes();

  // FAQ accordion
  document.querySelectorAll('.tp-faq__q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.parentElement;
      var wasOpen = item.classList.contains('on');
      document.querySelectorAll('.tp-faq__item').forEach(function(x){ x.classList.remove('on'); });
      if(!wasOpen) item.classList.add('on');
    });
  });
})();